// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__1p-EN","loginWrapper":"LoginPage_loginWrapper__PkhvA","logo":"LoginPage_logo__nifUZ"};